<template>
	<v-container fluid class="ma-0 pa-0">
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5" cols="12" align="center">
				<v-col class="ma-0 pa-0 mt-15" cols="12" id="group_box">
					<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
						<template v-if="searchOn == false && shareOn == false">
							{{tg('createTitle')}}
						</template>
						<template v-if="searchOn == true && filterOn == false">
							{{t('storeSearch')}}
						</template>
						<template v-if="searchOn == true && filterOn == true">
							{{t('storeSearch')}}
						</template>
						<template v-if="searchOn == false && shareOn == true">
							{{t('sharUserSetting')}}
						</template>
					</v-col>
					<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12" align="left"
						v-if="searchOn == false && shareOn == false">
						<v-col class="ma-0 pa-0 pb-2" cols="12">{{tg('nameInput')}}</v-col>
						<v-col class="ma-0 pa-0 pb-5" cols="12">
							<input class="group_input" :placeholder="tg('nameInputPlaceholder')"
								style="width:100%;height:2rem;" v-model="groupName">
						</v-col>
						<v-col class="ma-0 pa-0 pb-2" cols="12">{{tg('storeNameInput')}}</v-col>
						<v-col class="ma-0 pa-0 pb-3" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<!-- vuetify Autocompletes API search 사용할것 -->
								<v-autocomplete
									v-model="storeSearchInputValue"
									:items="searchResult"
									:loading="searchLoading"
									:search-input.sync="search" append-icon=""
									color="white" dark hide-no-data hide-selected outlined dense hide-details
									item-text="customerName"
									:placeholder="tg('storeNameInputPlaceholder')"
									return-object style="width:67%;"
								></v-autocomplete>
								<v-btn width="12%" height="auto" class="blue_btn ma-0 pa-2 ml-2" 
									id="blue_btn1" elevation="0" @click="addStore">
										{{tg('add')}}
								</v-btn>
								<v-btn width="18%" height="auto" class="blue_btn ma-0 pa-2 ml-2" 
									id="blue_btn2" elevation="0" @click="searchOn = true">
										{{tg('search')}}
								</v-btn>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0" cols="12" id="store_list">
							<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
								v-for="(item, index) in selectedStoreList" :key="index">
								<v-col class="ma-0 pa-2 pt-1 pb-1" cols="12" id="store_item">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										{{item.customerName}}
										<v-btn width="auto" height="auto" class="ma-0 pa-0 mr-5" 
											id="back_clean_btn" elevation="0" @click="deleteStore(index)">
											<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
												src="@/assets/images/close.png"></v-img>
										</v-btn>
									</v-row>
								</v-col>
							</v-col>
						</v-col>
						<v-col class="ma-0 pa-0" cols="12">
							<v-col class="ma-0 pa-0 pt-3 pb-2" cols="12">{{tg('selectLabel')}}</v-col>
							<v-select class="ma-0 pa-0" v-model="selectedLabelId"
								:items="labelList" dense hide-details outlined
								dark item-text="labelName" item-value="id"
							></v-select>
						</v-col>
						<v-col class="ma-0 pa-0 mt-5" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<v-btn width="8rem" height="auto" class="ma-0 pa-2 mr-3" 
									id="grey_btn" elevation="0" @click="cancelGroup">
										{{tg('cancel')}}
								</v-btn>
								<v-btn width="8rem" height="auto" class="blue_btn ma-0 pa-2" 
									id="blue_btn3" elevation="0" @click="makeGroup">
										{{tg('create')}}
								</v-btn>
							</v-row>
						</v-col>
					</v-col>


					<!-- ###### 점포 검색 -->
					<v-row class="ma-0 pa-0" justify="center"
						v-if="searchOn == true && filterOn == false">
						<v-col class="ma-0 pa-3 pt-5 pb-5" cols="12">
							<v-col id="brand_box" class="ma-0 pa-0" cols="12">
								<v-row class="ma-0 pa-0" align="center" justify="start">
									<template v-if="brandLoading == false">
										<v-item-group class="ma-0 pa-0" dense v-model="selectedBrands" dark
											hide-details :column="false" multiple>
											<v-row class="ma-0 pa-0" align="center">
												<v-col class="ma-0 pa-0 ml-1 mr-1 mb-1" cols="auto" 
													v-for="(item, index) in brandList" :key="index">
													<v-item :value="item" v-slot="{ active, toggle }">
														<v-col class="ma-0 pa-2 grey_item" cols="auto" @click="toggle"
															:class="{'selected_item':active}">
															<v-row class="ma-0 pa-0" align="center">
																<template v-if="active">
																	<input id="check_box" type="checkbox" :checked="active" />
																</template>
																<template v-else>
																	<input id="check_box" type="checkbox" :checked="active" />
																</template>
																<v-col class="ma-0 pa-0 ml-2" cols="auto">
																	{{item.brandName + ' (' + item.count + ')'}}
																</v-col> 
															</v-row>
														</v-col>
													</v-item>  
												</v-col>
											</v-row>       
										</v-item-group>
									</template>
									<template v-else>
										<v-col class="ma-0 pa-0 ml-5" cols="auto">
											<v-progress-circular indeterminate color="white"
												:width="4" :size="30"></v-progress-circular>
										</v-col>
									</template>
								</v-row>
							</v-col>
							<v-row class="ma-0 pa-0 pl-2" align="center"
								v-if="selectedBrands.length != 0 && uacSupport">
								{{t('theConditions')}}:
								<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-5" 
									id="back_clean_btn" elevation="0" @click="filterOn = true">
									<v-row class="ma-0 pa-0" align="center" style="color:white;">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/plus_white.png"></v-img>
										{{t('filtering')}}
									</v-row>
								</v-btn>
							</v-row>
							<template v-if="areaLoading == false">
								<v-row class="ma-0 pa-0 pb-2" justify="start">
									<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
										<template v-if="storeList.length > 0">
											<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12">
												<v-treeview selected-color="blue"
													selectable dark dense v-model="selectedStores" 
													:items="storeList" item-key="id" return-object>
													<template v-slot:label="{item}">
														<v-col class="ma-0 pa-0" cols="auto">
															{{item.id}}
														</v-col>
													</template>
												</v-treeview>
											</v-col>
										</template>
										<template v-else-if="storeList.length == 0 && selectedBrands.length != 0 && selectedStores.length == 0">
											<v-col class="ma-0 pa-10" cols="12">
												{{t('noData')}}
											</v-col>
										</template>
									</v-col>
								</v-row>
							</template>
							<template v-else>
								<v-row class="ma-0 pa-0 pb-2" justify="start">
									<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
										<v-skeleton-loader
											:boilerplate="false" elevation="0" dark 
											type="list-item-three-line, list-item-two-line, list-item-three-line"
										></v-skeleton-loader>
									</v-col>
								</v-row>
							</template>
							<v-row class="ma-0 pa-0 pt-2 pb-2" align="center" justify="center">
								<v-btn class="ma-0 pa-0" width="8rem" height="2rem" id="grey_btn" 
									@click="searchCancel">{{t('back')}}</v-btn>
								<v-btn class="blue_btn ma-0 pa-0 ml-2" width="8rem" height="2rem" id="blue_btn4" 
									@click="searchOn = false">{{t('add')}}</v-btn>
							</v-row>
						</v-col>
					</v-row>


					<!-- ############# 필터링 부분 -->
					<v-row class="ma-0 pa-0" justify="center" v-if="filterOn">
						<Filtering :filterOn="filterOn"
							@close="filterCloseFunc" @close2="filterClose2Func"
							@getArea="getAreaFunc" />
					</v-row>


					<!-- ##### 공유 유저 설정 -->
					<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12" align="left"
						v-if="shareOn == true && searchOn == false">
						<v-col class="ma-0 pa-0 pb-5" cols="12">
							<v-row class="ma-0 pa-0" align="center">
								<v-col class="ma-0 pa-0 pr-2" cols="10">
                  <v-autocomplete
								  	v-model="shareUserInputValue"
								  	:items="allShareUserList"
								  	:loading="searchLoading"
								  	:search-input.sync="search" append-icon=""
								  	color="white" dark hide-no-data hide-selected outlined dense hide-details
								  	item-text="name"
								  	:placeholder="tg('shareInputPlaceholder')"
								  	return-object style="width:100%;"
								  ></v-autocomplete>
								</v-col>
								<v-col class="ma-0 pa-0" cols="2">
									<v-btn width="100%" height="2rem" class="blue_btn ma-0 pa-0" 
										id="blue_btn6" elevation="0" @click="addShareUser">
											{{t('add')}}
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0" cols="12" id="store_list">
							<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
								v-for="(item, index) in shareUserList" :key="index">
								<v-col class="ma-0 pa-2 pt-1 pb-1" cols="12" id="user_item">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										<v-col class="ma-0 pa-0 pl-3" cols="auto">{{item.name}}</v-col>
										<v-col class="ma-0 pa-0" cols="auto">{{item.mailAddress}}</v-col>
										<v-btn width="auto" height="auto" class="ma-0 pa-0 mr-5" 
											id="back_clean_btn" elevation="0" @click="deleteShareUser(index)">
											<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
												src="@/assets/images/close.png"></v-img>
										</v-btn>
									</v-row>
								</v-col>
							</v-col>
						</v-col>
						<v-col class="ma-0 pa-0 mt-5" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
									id="grey_btn" elevation="0" @click="shareOn = false">
										{{t('back')}}
								</v-btn>
								<v-btn width="8rem" height="auto" class="blue_btn ma-0 pa-2 ml-2" 
									id="blue_btn7" elevation="0" @click="requestAddStoreGroup" :loading="addLoading">
										{{tg('groupCreate')}}
								</v-btn>
							</v-row>
						</v-col>
					</v-col>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Filtering from './components/Filtering.vue'
import { isEmpty } from 'lodash';
export default {
	components: {
		Filtering
	},
	mixins: [mixin.common],
	data: () => ({
		userConfig: {},
		groupName: '',
		brandLoading: false,
		addLoading: false,
		groupLabelList: [],
		selectedLabelId: null,
		brandList: [],
		selectedBrands: [],
		brandTotal: 0,
		selectedStores: [],
		selectedStoreList: [],
		setStoreListParams: [],
		storeList: [],
		searchOn: false,
		filterOn: false,
		shareOn: false,
		areaLoading: false,
		storeSearchInputValue: null,
		allShareUserList: [],
		shareUserList: [],
		setshareUserListParams: [],
		shareUserInputValue: {},

    searchLoading: false,
    model: null,
    search: null,
		searchResult: [],
		uacSupport: true,
	}),
	computed: {
		labelList() {
			let result = [];
			this.groupLabelList.forEach((label) => {
				if(label.labelName) {
					result.push(label);
				}
			})
			return result;
		}
	},
	watch: {
		searchOn: function(item) {
			if(item) this.getBrandData();
			else this.selectedBrands = [];
		},
		selectedBrands: function(item) {
			console.log('%cselectedBrands\n', "color:#008DD0;", item);
      if(item.length != 0) {
			  this.getAreaStores('','','','');
        this.brandTotal = item.count;
      } else {
        this.storeList = [];
      }
		},
		selectedStores: function(item) {
			let storeArray = [];
			item.forEach((store) => {
				let temp = store.value != undefined ? store.value[0] : store;
				storeArray.push(temp)
			})
			console.log('%cselectedStores\n', "color:#008DD0;", storeArray);
			let makeStoreList = storeArray.map(element => {
				return {
					customerName: element.customerName,
					unisCustomerCd: element.unisCustomerCd
				}
			});
			// let sum = [ ...this.selectedStoreList, ...makeStoreList ];
			let sum = [ ...makeStoreList ];
			// 중복제거
			const result = sum.filter((v, i) => 
  			sum.findIndex(x => x.customerName === v.customerName) === i);
			this.selectedStoreList = result;

			let makeStoreListParams = storeArray.map(element => {
				return {
					customerName: element.customerName,
					unisCustomerCd: element.unisCustomerCd,
          areaCd: element.areaCd
				}
			});
			// let sum2 = [ ...this.setStoreListParams, ...makeStoreListParams ];
			let sum2 = [ ...makeStoreListParams ];
			// 중복제거
			const result2 = sum2.filter((v, i) => 
  			sum2.findIndex(x => x.customerName === v.customerName) === i);
			this.setStoreListParams = result2;
		},
		shareUserList: function(item) {
			this.setshareUserListParams = item.map(element => {
				return {
					customerName: element.userName,
					mailAddress: element.mailAddress
				}
			});
			console.log(this.setshareUserListParams);
		},
		search(val) {
			this.requestStoreSearch(val);
		},
		'$store.state.userData.storeGroupLabel': {
      deep: true,
      handler(val, oldVal) {
        this.groupLabelList = val;
      }
    },
	},
	created() {
		this.userConfig = this.$store.getters.getUserConfig;
		this.uacSupport = this.$store.getters.getUacSupport;
	},
	mounted() {
		this.getAllShareUserList();
		this.groupLabelList = this.$store.getters.getStoreGroupLabel;
		if(this.$store.getters.getSelectedStoreMakeStoreGroup != null) {
			const store = this.$store.getters.getSelectedStoreMakeStoreGroup;
			this.selectedStores.push({
				id: store.unisCustomerName,
				value: [store]
			});
			this.$store.commit('setSelectedStoreMakeStoreGroup', null);
		}
	},
	methods: {
		tg(t) {
      return this.$t("lang.group." + t);
    },
		groupNameCheckDuplicate() {
			let savedStoreGroupList = this.$store.getters.getStoreGroupList;
			if(savedStoreGroupList.length > 0) {
				let duplicateCheck = savedStoreGroupList.some((element) => {
					return element.groupName === this.groupName
				});
				if(duplicateCheck == false) {
					return false;
				} else { // duplicateCheck가 true일때는 groupName 중복
					return true;
				}
			} else {
				return false;
			}
		},
		makeGroup() {
			if(this.groupName == '') {
				this.showToastMessage(this.tmb('requiredGroupName'));
				return;
			} else if(this.checkStringBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			} else if(this.checkStringOnlyBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			} else if(this.setStoreListParams.length == 0) {
				this.showToastMessage(this.tmb('requiredGroupStore'));
				return;
			} else {
				if(this.groupNameCheckDuplicate()) {
					this.showToastMessage('既に存在するグループ名です。');
					return;
				}
				else this.shareOn = true;
			}
		},
    cancelGroup() {
      this.$router.back();
    },
		requestAddStoreGroup() {
			this.addLoading = true;
			let params = {
				groupName: this.groupName,
				sharedUserStoreGroups: this.shareUserList,
				stores: this.setStoreListParams,
				id: this.$store.getters.getUmid,
				storeGroupLabelId: this.selectedLabelId
			};
			this.networkController.addStoreGroup(params)
			.then((res) => {
				const groupData = res.data;
				console.log(res.data);

				this.networkController.getStoreGroupLabel({}).then((response) => {
					console.log('%cFetch Store Group Label\n', "color:#008DD0;", response.data);
					this.$store.commit('setStoreGroupLabel', response.data);

					let newStoreGroupList = this.$store.getters.getStoreGroupList;
					newStoreGroupList.push(groupData);
					this.$store.commit('setStoreGroupList', newStoreGroupList);
					this.showToastMessage(this.tmb('successAddGroup'));
					this.addLoading = false;

					this.pushRoute(`/store-group/detail?groupId=${groupData.id}`, {});
				}).catch(error => {
					this.addLoading = false;
				});
			}).catch(error => {
				this.addLoading = false;
			});
		},
		async getBrandData() {
			this.brandLoading = true;
			let params = {};
			await this.networkController.getBrandList(params).then(async (res) => {
				console.log('%cBrand Data\n', "color:#008DD0;", res.data);
				this.brandLoading = false;
        this.brandList = res.data;
			}).catch(error => {
				this.brandLoading = false;
			});
		},
		makeBrandCd() {
			if(this.selectedBrands.length == 0) return '';
			return new Promise((resolve, reject) => {
				let brandCd = '';
				this.selectedBrands.forEach((item, index) => {
					if(index == 0) brandCd = item.brandCd;
					else brandCd = brandCd + ',' + item.brandCd;
				});
				// brandCd = this.selectedBrands.brandCd;
				resolve(brandCd);
			});
		},
		async getAreaStores(motionBeginDate, motionEndingDate, soundBeginDate, soundEndingDate) {
			this.areaLoading = true;
			let brandCd = await this.makeBrandCd();
			let params = {};
			this.storeList = [];
			await this.networkController.getStoresModalSearch(params, brandCd,
			  motionBeginDate, motionEndingDate, soundBeginDate, soundEndingDate)
			.then(async (res) => {
				console.log('%cArea Stores Data\n', "color:#008DD0;", res.data);

				if(this.userConfig.printCityName) {
					let group1 = this.groupBy(res.data, data => data.unisCustomerPref)
					group1.forEach((item, index) => {
						let group2 = this.groupBy(item.value, data => data.areaName)
						group1[index].children = group2;
						group2.forEach((item, index2) => {
							let group3 = this.groupBy(item.value, data => data.unisCustomerName)
							group2[index2].children = group3;
						})
					})
					this.storeList = group1;
				} else {
					let group1 = this.groupBy(res.data, data => data.unisCustomerPref)
					group1.forEach((item, index) => {
						let group2 = this.groupBy(item.value, data => data.unisCustomerName)
						group1[index].children = group2;
					})
					this.storeList = group1;
				}

				this.areaLoading = false;
			}).catch(error => {
				this.areaLoading = false;
			});
    },
		groupByChildren(list, keyGetter) {
			const map = new Map();
			list.forEach((item) => {
				const key = keyGetter(item);
				const collection = map.get(key);
				if (!collection) {
					map.set(key, [item]);
				} else {
					collection.push(item);
				}
			});
			return Array.from(map, ([id, value]) => ({ id, children: value }));
		},
		deleteStore(index) {
			this.selectedStores = this.selectedStoreList.filter((el) => el.unisCustomerCd !== this.selectedStoreList[index].unisCustomerCd)
			this.selectedStoreList.splice(index, 1);
			this.setStoreListParams.splice(index, 1);
		},
		async requestStoreSearch(value) {
			this.searchLoading = true;
			let params = {};
			await this.networkController.getStoreDataFromStoreName(params, value)
			.then(async (res) => {
				console.log('%cStore Search\n', "color:#008DD0;", res.data);
				this.searchResult = res.data;
				this.searchLoading = false;
			}).catch(error => {
				this.searchLoading = false;
			});
		},
		addStore() {
			this.checkStoreExistence().then((store) => {
				if(store != undefined) {
					let duplicateCheck = this.selectedStoreList.some((element) => {
						return element.customerName === store.customerName
					});
					if(duplicateCheck == false) { // duplicateCheck가 true일때는 customerName 중복
						this.selectedStores.push({
							customerName: store.customerName,
							unisCustomerCd: store.unisCustomerCd,
              areaCd: store.areaCd,
						});
						this.setStoreListParams.push({
							customerName: store.customerName,
							unisCustomerCd: store.unisCustomerCd,
              areaCd: store.areaCd,
						});
						this.selectedStoreList.push({
							customerName: store.customerName,
							unisCustomerCd: store.unisCustomerCd
						});
					} else {
						this.showToastMessage(this.tmb('storeAlreadyAdded'));
					}
				} else {

				}
			}).catch((error) => {
				console.log(error);
			});
		},
		checkStoreExistence() {
			return new Promise((resolve, reject) => {
				let result = undefined;
				if(this.storeSearchInputValue == null) reject(undefined);
				this.searchResult.forEach((item, index, array) => {
					if(item.customerName === this.storeSearchInputValue.customerName) {
						result = item;
					}
					if (index === array.length - 1) {
						resolve(result);
					}
				});
			});
		},
		async getAllShareUserList() {
			let params = {};
      let unisCustomerCd = this.$store.getters.getUserDetail.unisCustomerCd;
			await this.networkController.getShareUser(params, unisCustomerCd).then(async (res) => {
				const userList = this.checkShareUserList(res.data.accounts);
				console.log('%cShare user account\n', "color:#008DD0;", userList);
				this.allShareUserList = userList;
			}).catch(error => { });
		},
		addShareUser() {
			const { name, mailAddress, umid, userName } = this.shareUserInputValue || {};

			if (isEmpty(name)) {
				this.showToastMessage(this.tmb('failAddShareUser'));
				return;
			}

			if (isEmpty(mailAddress)) {
				this.showToastMessage('そのユーザーはメールアドレスを持たないユーザーです。');
				return;
			}

			const isAlreadyAdded = this.shareUserList.some(user => user.umid === umid);
			if (isAlreadyAdded) {
				this.showToastMessage(this.tmb('userAlreadyAdded'));
				return;
			}

			this.shareUserList.push({ mailAddress, umid, name, userName });
			this.shareUserInputValue = {};		
			/*
			if(this.shareUserInputValue != undefined && this.shareUserInputValue.userName != null) {
				let arrayCheck = this.shareUserList.some((element) => {
					return element.userName === this.shareUserInputValue.userName
				});
				if(arrayCheck == false) {
					if(this.shareUserInputValue.mailAddress == '') {
						this.showToastMessage('そのユーザーはメールアドレスを持たないユーザーです。');
						return;
					}
          this.shareUserList.push({
            mailAddress: this.shareUserInputValue.mailAddress,
            umid: this.shareUserInputValue.umid,
            userName: this.shareUserInputValue.userName,
						name: this.shareUserInputValue.name,
          });
          this.shareUserInputValue = {};
				} else {
					this.showToastMessage(this.tmb('userAlreadyAdded'));
          this.shareUserInputValue = {};
				}
			} else {
				this.showToastMessage(this.tmb('failAddShareUser'));
        this.shareUserInputValue = {};
			}
			*/
		},
		deleteShareUser(index) {
			this.shareUserList.splice(index, 1);
		},
		filterCloseFunc(value) {
			this.filterOn = value;
		},
		filterClose2Func(value) {
			this.filterOn = value;
		},
		getAreaFunc(obj) {
			this.getAreaStores(obj.motionBegin, obj.motionEnd, obj.soundBegin, obj.soundEnd);
		},
		searchCancel() {
			this.selectedStores = [];
			this.searchOn = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.blue_btn {
	background-color: #008DD0 !important;
	color: white;
	border-radius: 4px;
	min-width: 1rem;
}
.grey_item {
	cursor: pointer;
	border: 1px solid #6A6A6A;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
}
.selected_item {
	cursor: pointer;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
	border: 1px solid #6A6A6A;
}
#brand_box {
	max-height: 100px;
  overflow: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	font-size: 0.9rem;
	font-weight: bold;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
}
#store_list {
	border: 1px solid #4A4A4A;
	overflow: auto;
	min-height: 300px;
	max-height: 300px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#noneBorderBox {
	min-height: 350px;
	max-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
.group_input {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 4px;
	color: white;
	padding: 5px;
}
#store_item {
	border-bottom: 1px solid #4A4A4A;
}
.v-list{
  background: #171921;
	border: 1px solid #4A4A4A;
	overflow: auto;
  max-height: 200px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node .v-treeview-node--leaf {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__checkbox { // 트리뷰 체크박스 CSS
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
	.v-input__slot {
		padding-right: 2px !important;
		min-height: 2rem !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
		// v-skeleton-loader css 설정
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
		background: #171921 !important;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #171921 !important;
	}

	.v-autocomplete {
		background-color: #272727;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 30px !important;
		background: #272727;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#picker_bottom_menu {
	background-color: #272727;
  border: 1px solid #4A4A4A;
  color: white;
  justify-content: start;
}
#user_item {
	border-bottom: 1px solid #4A4A4A;
}
</style>